import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Phone-Mobile-Phone--Streamline-Flex"
    >
        <desc>
            {'Phone Mobile Phone Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="phone-mobile-phone--android-phone-mobile-device-smartphone-iphone">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.41367 11.0936c0.09697 1.2218 0.98715 2.2221 2.13644 2.3103 1.66894 0.1281 3.23084 0.1281 4.89978 0 1.14931 -0.0882 2.03951 -1.0885 2.13641 -2.3103 0.2183 -2.74966 0.2183 -5.43754 0 -8.18724 -0.0969 -1.2218 -0.9871 -2.222097 -2.1364 -2.310298 -1.66895 -0.128083 -3.23085 -0.128083 -4.8998 0C3.40082 0.684263 2.51064 1.68456 2.41367 2.90636c-0.21823 2.7497 -0.21823 5.43758 0 8.18724Z"
                strokeWidth={1}
            />
            <path
                id="Vector 122"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.09863 10.9751h1.80333"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
